// extracted by mini-css-extract-plugin
export var container = "comment-form-module--container--NiJS+";
export var flexDoubles = "comment-form-module--flexDoubles--xoSIm";
export var field = "comment-form-module--field--UDw-T";
export var flexFull = "comment-form-module--flexFull--Yr2dr";
export var submitButton = "comment-form-module--submitButton--osmWO";